import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'card-already-registered-dialog',
    templateUrl: './cardAlreadyRegisteredDialog.component.html',
    styleUrls: ['./cardAlreadyRegisteredDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CardAlreadyRegisteredDialogComponent {
    constructor(
        public matDialogRef: MatDialogRef<CardAlreadyRegisteredDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
    ) {

    }

}
